import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Form, Formik } from "formik";
import CustomConfirmBox from "./customConfirmBox";
import { toast } from "react-toastify";
import { toastProperties } from "../../commons/Toast/Toaster";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import "../DashBoard/dashboard.css";
import biddingGeneratorService from "../../components/Services/biddingGenerator.service";
import biddingConsumerService from "../../components/Services/biddingConsumer.service";
import Chat from "../../components/chat/Chat";
import { CircularProgress } from '@mui/material';
import LccTables from "./lccTables";
import { disableButton, enableButton } from "../../store/ButtonFlag/actions";

const ApproveBidsModal = ({ isOpen, closeApproveBidsModal, getReceivedBidsGenerator, jsonData, getReceivedBidsConsumer, comparedBids,getMatchingProfiles,selectedCardData }) => {
  const dispatch = useDispatch();
  const role = useSelector(state => state?.sessionState?.role)
  const configKey = useSelector(state => state?.sessionState?.connectionName)
  const isButtonEnabled = useSelector((state) => state?.buttonReducer?.isButtonEnabled);

  const [approveOpen, setApproveOpen] = useState(false);
  const [closeConnectionOpen, setCloseConnectionOpen] = useState(false);
  const [rejectOpen, setRejectOpen] = useState(false);
  const [withdrawOpen, setWithdrawOpen] = useState(false);
  const [isOpenChat, setOpenChat] = useState(false);
  const [rejectConnection, setRejectConnection] = useState(false)
  const currentRoute = window.location.pathname;

  const handleApprove = () => {
    setApproveOpen(true);
  }
  const handleCloseConnection = () => {
    setCloseConnectionOpen(true);
  }
  const handleCloseYes = () => {
    disableButton()(dispatch);
    const data = {
      id: jsonData?.id,
      status: "CLOSED",
      isPlaced: true
    }
    if (role === "CONSUMER") {
      biddingGeneratorService.updateConnectionStatus(data).then((response) => {
        if (response?.data?.code === 200) {
          setCloseConnectionOpen(false);
          closeApproveBidsModal();
          // jsonData && getReceivedBidsConsumer()
          toast.success("Status updated successfully", toastProperties)
          window.location.replace("/consumer_dashboard");
          enableButton()(dispatch);
        }else if(response?.data?.code !== 200){
          enableButton()(dispatch);
        }
      }).catch(error => {console.error("Api call Error :", error); enableButton()(dispatch);})
    } else if (role === "GENERATOR") {
      biddingConsumerService.updateConnectionStatus(data).then((response) => {
        if (response?.data?.code === 200) {
          setCloseConnectionOpen(false);
          closeApproveBidsModal();
          // jsonData && getReceivedBidsGenerator()
          toast.success("Status updated successfully", toastProperties)
          window.location.replace("/dashboard");
          enableButton()(dispatch);
        }else if(response?.data?.code !== 200){
          enableButton()(dispatch);
        }
      }).catch(error => {console.error("Api call Error :", error); enableButton()(dispatch);})
    }

  }
  const handleCloseNo = () => {
    setCloseConnectionOpen(false);
  }
  const handleApproveClose = () => {
    disableButton()(dispatch);
    let rejectState = localStorage.getItem('RejectedReason')
    const data = {
      id: jsonData?.id ? jsonData?.id : comparedBids?.sourceCapacity?.bidId,
      status: jsonData?.id ? "ACCEPTED" : "CLOSED",
      isPlaced: (currentRoute === '/dashboard' || currentRoute === '/consumer_dashboard') ? true : false
    }
    if (role === "GENERATOR") {
      biddingGeneratorService.updateConnectionStatus(data).then((response) => {
        if (response?.data?.code === 200) {
          setApproveOpen(false);
          closeApproveBidsModal();
          jsonData && getReceivedBidsGenerator()
          toast.success("Status updated successfully", toastProperties)
          enableButton()(dispatch);
        }else if(response?.data?.code !== 200){
          enableButton()(dispatch);
        }
      }).catch(error => {console.error("Api call Error :", error); enableButton()(dispatch);})
    } else if (role === "CONSUMER") {
      biddingConsumerService.updateConnectionStatus(data).then((response) => {
        if (response?.data?.code === 200) {
          setApproveOpen(false);
          closeApproveBidsModal();
          jsonData && getReceivedBidsConsumer()
          toast.success("Status updated successfully", toastProperties)
          enableButton()(dispatch);
        }else if(response?.data?.code !== 200){
          enableButton()(dispatch);
        }
      }).catch(error => {console.error("Api call Error :", error); enableButton()(dispatch);})
    }

  }
  const handleApproveCloseNo = () => {
    setApproveOpen(false);
  }

  const handleReject = () => {
    setRejectOpen(true)
    setRejectConnection(true)
  }

  const handleRejectClose = () => {
    disableButton()(dispatch);
    let rejectState = localStorage.getItem('RejectedReason')
    const data = {
      id: jsonData?.id ? jsonData?.id : comparedBids?.sourceCapacity?.bidId,
      status: "REJECTED",
      reason: rejectState !== "null" ? rejectState : null,
      isPlaced: (currentRoute === '/dashboard' || currentRoute === '/consumer_dashboard') ? true : false
    }
    if (role === "GENERATOR") {
      biddingGeneratorService.updateConnectionStatus(data).then((response) => {
        if (response?.data?.code === 200) {
          setRejectOpen(false)
          setRejectConnection(false)
          closeApproveBidsModal();
          jsonData && getReceivedBidsGenerator()
          toast.success("Status updated successfully", toastProperties)
          enableButton()(dispatch);
        }else if(response?.data?.code !== 200){
          enableButton()(dispatch);
        }
      }).catch(error => {console.error("Api call Error :", error); enableButton()(dispatch);})
    } else if (role === "CONSUMER") {
      biddingConsumerService.updateConnectionStatus(data).then((response) => {
        if (response?.data?.code === 200) {
          setRejectOpen(false)
          setRejectConnection(false)
          closeApproveBidsModal();
          jsonData && getReceivedBidsConsumer()
          toast.success("Status updated successfully", toastProperties)
          enableButton()(dispatch);
        }else if(response?.data?.code !== 200){
          enableButton()(dispatch);
        }
      }).catch(error => {console.error("Api call Error :", error); enableButton()(dispatch);})
    }
  }
  const handleRejectCloseNo = () => {
    setRejectOpen(false)
  }
  const handleWithdraw = () => {
    setWithdrawOpen(true)
    // setRejectConnection(true)
  }
  const handleWithdrawClose = () => {
    disableButton()(dispatch);
    const data = {
      id: jsonData?.id ? jsonData?.id : comparedBids?.sourceCapacity?.bidId,
      status: "WITHDRAWN",
      isPlaced: (currentRoute === '/dashboard' || currentRoute === '/consumer_dashboard') ? true : false
    }
    if (role === "GENERATOR") {
      biddingGeneratorService.updateConnectionStatus(data).then((response) => {
        if (response?.data?.code === 200) {
          setWithdrawOpen(false)
          closeApproveBidsModal();
          jsonData && getReceivedBidsGenerator()
          getMatchingProfiles && getMatchingProfiles(selectedCardData?.id)
          toast.success("Status updated successfully", toastProperties)
          enableButton()(dispatch);
        }else if(response?.data?.code !== 200){
          enableButton()(dispatch);
        }
      }).catch(error => {console.error("Api call Error :", error); enableButton()(dispatch);})
    } else if (role === "CONSUMER") {
      biddingConsumerService.updateConnectionStatus(data).then((response) => {
        if (response?.data?.code === 200) {
          setWithdrawOpen(false)
          closeApproveBidsModal();
          jsonData && getReceivedBidsConsumer()
          getMatchingProfiles && getMatchingProfiles(selectedCardData?.id)
          toast.success("Status updated successfully", toastProperties)
          enableButton()(dispatch);
        }else if(response?.data?.code !== 200){
          enableButton()(dispatch);
        }
      }).catch(error => {console.error("Api call Error :", error);enableButton()(dispatch);})
    }
  }
  const handleWithdrawCloseNo = () => {
    setWithdrawOpen(false)
  }
  const roleStatus = comparedBids && (role === 'GENERATOR' ? comparedBids?.generatorStatus !== 'ACCEPTED' : comparedBids?.consumerStatus !== 'ACCEPTED');
  const finalListing = comparedBids && (role === 'GENERATOR' ?  comparedBids?.consumerStatus == "CLOSED" : comparedBids?.generatorStatus  == "CLOSED");
  const finalMyCapacity = comparedBids && (role === 'GENERATOR' ? comparedBids?.consumerStatus == 'ACCEPTED' : comparedBids?.generatorStatus == 'ACCEPTED');
  const acceptedStatus = comparedBids && (role === 'GENERATOR' ? comparedBids?.generatorStatus == 'ACCEPTED' : comparedBids?.consumerStatus == 'ACCEPTED');
const senderStatus = comparedBids && (
  (currentRoute === '/dashboard' || currentRoute === '/consumer_dashboard') &&
  (
    (role === 'GENERATOR' && comparedBids.consumerStatus === "ACCEPTED") ||
    (role === 'CONSUMER' && comparedBids.generatorStatus === "ACCEPTED")
  )
);

const listingStatus = comparedBids && (
  (role === 'GENERATOR' && comparedBids.generatorStatus !== "CLOSED") ||
  (role === 'CONSUMER' && comparedBids.consumerStatus !== "CLOSED")
);
  return (
    <>
      <Modal show={Boolean(isOpen)} onHide={closeApproveBidsModal} size="lg" centered >
        <Modal.Header closeButton>
          <Modal.Title>
            <span style={{textTransform:"capitalize"}}>
              {configKey} Request
            </span>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className="m-3 table-scrollY">
          <Formik>
            <Form>
              <div className=" table-responsive">
                 <table className="table comparasion-table table-bordered">
                  <tr>
                    <th width="33%"></th>
                    {roleStatus && <th width="33%" className="approve-comprasion-first-col-header">{finalMyCapacity? 'Final Listing':'My Listing' }</th>}
                    {(listingStatus && !senderStatus) && (<th width="33%" className="approve-comprasion-second-col-header">{(finalListing || currentRoute == '/capacity_listing' || acceptedStatus) ? 'Final Listing' : (role === 'CONSUMER' ? 'Generator Listing' : 'Consumer Listing')}</th>)}
                  </tr>
                  <tr>
                    <td className="comp-text-right">Name</td>
                    {roleStatus && <td className="approve-comprasion-first-col">{comparedBids?.sourceCapacity?.company?.companyName}{finalMyCapacity &&('-'+ comparedBids?.bidCapacity?.company?.companyName)}</td>}
                    {(listingStatus && !senderStatus) && <td className={acceptedStatus ? "approve-comprasion-second-col": "approve-comprasion-second-col company-name-blur"}>{comparedBids?.bidCapacity?.company?.companyName}{finalListing &&('-'+  comparedBids?.sourceCapacity?.company?.companyName)}</td>}
                  </tr>
                  <tr>
                    <td className="comp-text-right">Region</td>
                    {roleStatus && <td className="approve-comprasion-first-col">{comparedBids?.sourceCapacity?.company?.region}{finalMyCapacity &&('-'+ comparedBids?.bidCapacity?.company?.region)}</td>}
                    {(listingStatus && !senderStatus) && <td className="approve-comprasion-second-col">{comparedBids?.bidCapacity?.company?.region}{finalListing &&('-'+ comparedBids?.sourceCapacity?.company?.region)}</td>}
                  </tr>
                  <tr>
                    <td className="comp-text-right">State</td>
                    {roleStatus && <td className="approve-comprasion-first-col">{comparedBids?.sourceCapacity?.company?.state}{finalMyCapacity &&( '-'+ comparedBids?.bidCapacity?.company?.state)}</td>}
                   {(listingStatus && !senderStatus) && <td className="approve-comprasion-second-col">{comparedBids?.bidCapacity?.company?.state}{finalListing &&( '-'+ comparedBids?.sourceCapacity?.company?.state)}</td>}
                  </tr>
                  {/* <tr>
                    <td className="comp-text-right">Generator Cost Ex-bus (₹ per Unit)</td>
                    {roleStatus && <td className="approve-comprasion-first-col" style={{ color: role === 'CONSUMER' ? 'red' : 'green', fontWeight: role === 'CONSUMER' ? '' : '400' }}>{comparedBids?.sourceCapacity?.generatorPerUnitCost?.toFixed(2)}</td>}
                    {(listingStatus && !senderStatus) && <td className="approve-comprasion-second-col" style={{ color: role === 'CONSUMER' ? 'green' : 'red', fontWeight: role === 'CONSUMER' ? '400' : '' }}>{comparedBids?.bidCapacity?.generatorPerUnitCost?.toFixed(2)}</td>}
                  </tr>
                  <tr>
                    <td className="comp-text-right">Applicable Charges (₹ per Unit)</td>
                    {roleStatus && <td className="approve-comprasion-first-col" style={{ color: 'red' }}>{comparedBids?.sourceCapacity?.applicableCharges?.toFixed(2)}</td>}
                    {(listingStatus && !senderStatus) &&<td className="approve-comprasion-second-col" style={{ color: 'red' }}>{comparedBids?.bidCapacity?.applicableCharges?.toFixed(2)}</td>}
                  </tr>
                  <tr>
                    <td className="comp-text-right">Consumer Landed Cost (₹ per Unit)	</td>
                    {roleStatus && <td className="approve-comprasion-first-col" style={{ color: role === 'CONSUMER' ? 'green' : 'red', fontWeight: role === 'CONSUMER' ? '400' : '' }}>{comparedBids?.sourceCapacity?.consumerLandedCost?.toFixed(2)}</td>}
                    {(listingStatus && !senderStatus) &&<td className="approve-comprasion-second-col" style={{ color: role === 'CONSUMER' ? 'red' : 'green', fontWeight: role === 'CONSUMER' ? '' : '400' }}>{comparedBids?.bidCapacity?.consumerLandedCost?.toFixed(2)}</td>}
                  </tr> */}
                  <tr>
                    <td className="comp-text-right">Energy Rate(₹ per Unit)</td>
                    {roleStatus && <td className="approve-comprasion-first-col" style={{ color: 'green', fontWeight:'400' }}>{role === 'GENERATOR' ? comparedBids?.sourceCapacity?.generatorPerUnitCost?.toFixed(2) : comparedBids?.sourceCapacity?.consumerLandedCost?.toFixed(2)}</td>}
                    {(listingStatus && !senderStatus) && <td className="approve-comprasion-second-col" style={{ color: 'green', fontWeight: '400'}}>{role === 'CONSUMER' ? comparedBids?.bidCapacity?.generatorPerUnitCost?.toFixed(2) : comparedBids?.bidCapacity?.consumerLandedCost?.toFixed(2)}</td>}
                  </tr>
                  <tr>
                    <td className="comp-text-right">Credit Rating	</td>
                    {roleStatus && <td className="approve-comprasion-first-col">{comparedBids?.sourceCapacity?.company?.creditRating}</td>}
                    {(listingStatus && !senderStatus) &&<td className="approve-comprasion-second-col">{comparedBids?.bidCapacity?.company?.creditRating}</td>}
                  </tr>
                  <tr>
                    <td className="comp-text-right">Quantity (MW)</td>
                    {roleStatus && <td className="approve-comprasion-first-col" style={{ color: 'green', fontWeight: '400'}}>{comparedBids?.sourceCapacity?.energyInMW}</td>}
                    {(listingStatus && !senderStatus) &&<td className="approve-comprasion-second-col" style={{ color: 'green', fontWeight: '400'}}>{comparedBids?.bidCapacity?.energyInMW}</td>}
                  </tr>
                  <tr>
                    <td className="comp-text-right">Capacity Start & End Date	</td>
                    {roleStatus && <td className="approve-comprasion-first-col">{moment(comparedBids?.sourceCapacity?.dateStartAt).format('DD-MMM-yyyy')} / {moment(comparedBids?.sourceCapacity?.dateEndAt).format('DD-MMM-yyyy')}</td>}
                    {(listingStatus && !senderStatus) &&<td className="approve-comprasion-second-col">{moment(comparedBids?.bidCapacity?.dateStartAt).format('DD-MMM-yyyy')} / {moment(comparedBids?.bidCapacity?.dateEndAt).format('DD-MMM-yyyy')}</td>}
                  </tr>
                  <tr>
                    <td className="comp-text-right">Capacity Start & End Time	</td>
                    {roleStatus && <td className="approve-comprasion-first-col">{comparedBids?.sourceCapacity?.slotStartAt} / {comparedBids?.sourceCapacity?.slotEndAt && comparedBids?.sourceCapacity?.slotEndAt === "23:59" ? "24:00" : comparedBids?.sourceCapacity?.slotEndAt }</td>}
                    {(listingStatus && !senderStatus) &&<td className="approve-comprasion-second-col">{comparedBids?.bidCapacity?.slotStartAt} / {comparedBids?.bidCapacity?.slotEndAt && comparedBids?.bidCapacity?.slotEndAt === "23:59" ? "24:00" : comparedBids?.bidCapacity?.slotEndAt}</td>}
                  </tr>
                  <tr>
                    <td className="comp-text-right">Expiry Date/Time	</td>
                    {roleStatus && <td className="approve-comprasion-first-col">{comparedBids?.sourceCapacity?.expiryAt}</td>}
                    {(listingStatus && !senderStatus) &&<td className="approve-comprasion-second-col">{comparedBids?.bidCapacity?.expiryAt}</td>}
                  </tr>
                </table>
              </div>
              {/* <div style={{ color: 'red', marginLeft: '70%', fontWeight: '400', fontSize: '18px' }}>*Indicative Calculated Cost</div> */}
              <div style={{ color: 'green', marginLeft: '80%', fontWeight: '400', fontSize: '18px' }}>*Listing Values</div>
            </Form>
          </Formik>
          <LccTables comparedBids={comparedBids} />
          {currentRoute !== '/capacity_listing' && <div className="company-profile-btn-group mt-4" style={{ justifyContent: 'center' }}>
            {currentRoute === '/bids_received' && <button
              className="btn btn-approve"
              type="button"
              disabled={
                ((role === 'GENERATOR' || role === 'CONSUMER') &&
                  comparedBids &&
                  (comparedBids[`${role.toLowerCase()}Status`] === 'RECEIVED'))
                  ? false
                  : true
              }
              onClick={handleApprove}
            >
              Accept
            </button>}

            {approveOpen && <CustomConfirmBox
              title="Connect"
              message={`Do you want to accept this ${configKey.toLowerCase()}?`}
              open={approveOpen}
              handleClose={handleApproveClose}
              handleCloseNo={handleApproveCloseNo}

            />}
            {currentRoute === '/bids_received' && comparedBids && (role === 'GENERATOR' ? comparedBids?.generatorStatus === 'ACCEPTED' : comparedBids?.consumerStatus === 'ACCEPTED') && (
              <button
                className="btn btn-approve"
                type="button"
                onClick={handleCloseConnection}
              // disabled={
              //   (role === 'GENERATOR' || role === 'CONSUMER') &&
              //   (currentRoute === '/bids_received' || currentRoute === '/dashboard' || currentRoute === '/consumer_dashboard') &&
              //   comparedBids &&
              //   (comparedBids[`${role.toLowerCase()}Status`] !== 'ACCEPTED' &&
              //   comparedBids[`${role.toLowerCase()}Status`] !== 'CLOSED')
              // }
              >
                Close
              </button>
            )}

            {closeConnectionOpen && <CustomConfirmBox
              title="Connect"
              message={`Do you want to close this ${configKey.toLowerCase()}?`}
              open={closeConnectionOpen}
              handleClose={handleCloseYes}
              handleCloseNo={handleCloseNo}
            />}
            {currentRoute === '/bids_received' && <button
              className="btn btn-withdrawal"
              type="button"
              disabled={
                ((role === 'GENERATOR' || role === 'CONSUMER') &&
                  (currentRoute === '/bids_received' || currentRoute === '/dashboard' || currentRoute === '/consumer_dashboard') &&
                  comparedBids &&
                  (comparedBids[`${role.toLowerCase()}Status`] === 'REJECTED' || (comparedBids[`${role.toLowerCase()}Status`] === 'WITHDRAWN')))
                  ? true
                  : false
              }
              onClick={handleReject}
            >
              Decline
            </button>}
            {rejectOpen && <CustomConfirmBox
              title="Decline"
              message={`Do you want to reject this ${configKey}?`}
              open={rejectOpen}
              rejectConnection={rejectConnection}
              handleClose={handleRejectClose}
              handleCloseNo={handleRejectCloseNo}
            />}
            <button className="btn btn-bookmark"
             type="button" onClick={() => { setOpenChat(true) }}
             disabled={
              ((role === 'GENERATOR' || role === 'CONSUMER') &&
              (currentRoute === '/bids_received' || currentRoute === '/dashboard' || currentRoute === '/consumer_dashboard') &&
                comparedBids &&
                ((comparedBids[`${role.toLowerCase()}Status`] === 'REJECTED') 
                || (comparedBids[`${role.toLowerCase()}Status`] === 'WITHDRAWN') || 
                (comparedBids[`${role.toLowerCase()}Status`] === 'RECEIVED')))
                ? true
                : false
            }
             >Chat</button>
            {/* <button className="btn btn-withdrawal" type="button" >Withdraw</button> */}
            {currentRoute !== '/bids_received' && <button
              className="btn btn-withdrawal"
              type="button"
              disabled={
                ((role === 'GENERATOR' || role === 'CONSUMER') &&
                  (currentRoute === '/dashboard' || currentRoute === '/consumer_dashboard') &&
                  comparedBids &&
                  comparedBids[`${role.toLowerCase()}Status`] !== 'WITHDRAWN')
                  ? false
                  : true
              }
              onClick={handleWithdraw}
            >
              Withdraw
            </button>}
            {withdrawOpen && <CustomConfirmBox
              title="Withdraw"
              message={`Do you want to withdraw this ${configKey}?`}
              open={withdrawOpen}
              handleClose={handleWithdrawClose}
              handleCloseNo={handleWithdrawCloseNo}
            />}
          </div>}
          {currentRoute === '/capacity_listing' && <div className="company-profile-btn-group mt-4" style={{ justifyContent: 'center' }}>
          <button className="btn btn-bookmark"
             type="button" onClick={() => { setOpenChat(true) }}
            //  disabled={
            //   ((role === 'GENERATOR' || role === 'CONSUMER') &&
            //   (currentRoute === '/bids_received' || currentRoute === '/dashboard' || currentRoute === '/consumer_dashboard') &&
            //     comparedBids &&
            //     ((comparedBids[`${role.toLowerCase()}Status`] === 'REJECTED') 
            //     || (comparedBids[`${role.toLowerCase()}Status`] === 'WITHDRAWN') || 
            //     (comparedBids[`${role.toLowerCase()}Status`] === 'RECEIVED')))
            //     ? true
            //     : false
            // }
             >Chat</button>
             </div>}
          {isOpenChat && <Chat isOpen={isOpenChat} closeChatModal={() => { setOpenChat(false) }} comparedBids={comparedBids} />}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ApproveBidsModal;
